




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Budget {
    campaign: {
        externalCode: string;
    };
}

@Component({ components: { SimpleText } })
export default class Code extends Vue {
    @Prop( { default: null }) public budget !: Budget;

    public static getNeededFields(): string[] {
        return [
            "budget.campaign.externalCode"
        ];
    }
}
